// Find all elements with the ID "cst-product-des" or "cst-product-top-des"
var elements = document.querySelectorAll("#Description.tabcontent");

// Loop through all found elements
elements.forEach(function (element) {
  // Replace all <h1> tags with <p> tags
  var html = element.innerHTML.replace(
    /<h1\b[^>]*>([\s\S]*?)<\/h1>/g,
    "<p><b>$1</b></p>"
  );

  // Set the new HTML content
  element.innerHTML = html;
});

// delaying script

window.addEventListener("load", function () {
  setTimeout(function () {
    var iframe = document.getElementById("rivo-form-13105-iframe");
    if (iframe) {
      iframe.style.display = "block";
      iframe.style.height = "375px";
    }
  }, 5000); // 5000 milliseconds = 5 seconds
});

// This code was earlier added on theme.liquid file
// I move this code here
// The code contain
// 1. Sorting Button Click Event:
// 2. Smooth Scrolling for Section Index Links:
// 3. Sidebar Custom Data Handling:

$(document).ready(function () {
  // Sorting Button Click Event
  $(".sorting_button").click(function () {
    $("#sort-by").val($(this).data("sortval")).trigger("change");
  });

  // Smooth Scrolling for Section Index Links
  $(".section_index ul li a").click(function () {
    var target = $("#" + $(this).data("id"));
    if (target.length) {
      $("html, body").animate({
        scrollTop: target.offset().top - 58,
      });
    }
  });

  $("ol.section_subindex li a").click(function () {
    var target = $("#" + $(this).data("id"));
    if (target.length) {
      $("html, body").animate({
        scrollTop: target.offset().top - 58,
      });
    }
  });

  // Sidebar Custom Data Handling
  if ($(".sidebar_custom_data").length > 0) {
    $(".sidebar_custom_data")
      .parent("div")
      .addClass("sidebar_custom_data_wrap");
    var sticky_offset = $(".sidebar_custom_data_wrap").offset().top - 60;

    $(window).scroll(function () {
      if (window.pageYOffset > sticky_offset) {
        var sidebar_custom_data_wrap = $(".sidebar_custom_data_wrap");
        var sidebar_custom_data_width = sidebar_custom_data_wrap
          .parent("div")
          .width();
        sidebar_custom_data_wrap.addClass("sidebar_sticky").css({
          width: sidebar_custom_data_width,
          position: "fixed",
        });
      } else {
        $(".sidebar_custom_data_wrap")
          .removeClass("sidebar_sticky")
          .removeAttr("style");
      }
    });
  }
});

// sticky add to cart code.

$(window).scroll(function () {
  if ($(window).scrollTop() > 600) {
    // 600px scroll position or adjust as needed
    $(".cst-sticky-atc").addClass("visible");
  } else {
    $(".cst-sticky-atc").removeClass("visible");
  }
});


// Timer code

// Step 1: Get the current time in Eastern Time (ET)
const easternTimeNow = new Date(
  new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
);

// Step 2: Set the target time to 2 PM Eastern Time (ET)
const targetTime = new Date(
  easternTimeNow.toLocaleString("en-US", { timeZone: "America/New_York" })
);
targetTime.setHours(14, 14, 0, 0); // Set target to 2 PM (14:00:00) Eastern Time (ET)

// Step 3: If the current time is already past 2 PM ET, set the target to 2 PM ET the next day
if (easternTimeNow > targetTime) {
  targetTime.setDate(targetTime.getDate() + 1); // Set target to next day's 2 PM
}

function updateCountdown() {
  // Get the current time in Eastern Time (ET)
  const now = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
  );

  const timeDifference = targetTime - now; // Difference in milliseconds

  // Calculate hours, minutes, and seconds
  const hours = Math.floor(timeDifference / (1000 * 60 * 60));
  const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

  // Output the result in an element with id="cst-countdown-timer"
  // Check if the element exists before updating it
  const countdownElement = document.getElementById("cst-countdown-timer");
  if (countdownElement) {
    countdownElement.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
  }

  // If the countdown reaches zero, stop the timer
  if (timeDifference <= 0) {
    clearInterval(countdownInterval);
    location.reload();
  }
}

// Start the countdown and update every second, but only if the element exists
const countdownElement = document.getElementById("cst-countdown-timer");
if (countdownElement) {
  countdownInterval = setInterval(updateCountdown, 1000);
} else {
  console.warn("Element with ID 'cst-countdown-timer' not found. Countdown will not start.");
}



// STICKY ADD TO CART SELECT FILED UPDATE

  // Wait for the window to fully load
  window.onload = function() {

    // Get the form elements
    const defaultForm = document.getElementById('cst-product-form');
    const stickyForm = document.getElementById('cst-stick-product-form');

    // Ensure that both forms exist on the page before proceeding
    if (!defaultForm || !stickyForm) {
      console.log('Forms not found!');
      return;
    }

    // Get the selects inside both forms (adjust this selector based on your form's actual structure)
    const defaultSelects = defaultForm.querySelectorAll('select');
    const stickySelects = stickyForm.querySelectorAll('select');

    // Ensure both forms have select elements
    if (defaultSelects.length === 0 || stickySelects.length === 0) {
      console.log('No select elements found in one or both forms!');
      return;
    }

    // Function to sync selections from the default form to the sticky form
    defaultSelects.forEach((select, index) => {
      select.addEventListener('change', function() {
        // console.log('Default form select changed:', select, 'New value:', select.value);
        if (stickySelects[index]) {
          stickySelects[index].value = select.value;
          // console.log('Sticky form select updated:', stickySelects[index], 'New value:', stickySelects[index].value);
        }
      });
    });

    // Function to sync selections from the sticky form to the default form
    stickySelects.forEach((select, index) => {
      select.addEventListener('change', function() {
        // console.log('Sticky form select changed:', select, 'New value:', select.value);
        if (defaultSelects[index]) {
          defaultSelects[index].value = select.value;
          // console.log('Default form select updated:', defaultSelects[index], 'New value:', defaultSelects[index].value);
        }
      });
    });
  };